import React from 'react';
import { observer } from 'mobx-react';
import { orderBy } from 'lodash';
import { Field, Select } from 'core/form';
import storeLoader, { InjectedStoreProps } from 'app/stores/storeLoader';
import BoardModel from 'app/stores/boards/BoardModel';

interface BoardsStore {
  collection: { get(): BoardModel[] };
}

interface BoardSelectorProps extends InjectedStoreProps<['$boards']> {
  fill?: boolean;
  large?: boolean;
  placeholder?: string;
  name?: string;
  showLabel?: boolean;
  rules?: string;
  mb?: number | string;
}

const BoardSelector = storeLoader('$boards')(
  observer(
    ({
      $boards,
      loading,
      fill = true,
      large = false,
      placeholder = 'Select a board...',
      ...rest
    }: BoardSelectorProps) => {
      if (loading || !$boards) {
        return null;
      }

      const store = $boards as BoardsStore;
      const boards = store.collection
        .get()
        .filter((board) => board.get('config')?.isDashboard && board.canEdit && !board.isNew);

      const sorted = orderBy(boards, [(b) => b.get('share_level'), (b) => b.name], ['asc', 'asc']);

      const options = sorted.map((board) => ({
        value: String(board.id),
        label: board.name,
        filterLabel: board.name
      }));

      return (
        <Field {...rest} options={options} large={large}>
          <Select showFilter fill={fill} placeholder={placeholder} />
        </Field>
      );
    }
  )
) as unknown as React.ComponentType<Omit<BoardSelectorProps, '$boards' | 'loading' | '$store'>>;

export default BoardSelector;
